import { ConfirmPhoneNumber } from "@low6dev/react-feature-auth/dist";
import { createImageCdnLink } from "@low6dev/react-utils/dist";
import { useLocation } from "react-router-dom";
import { handleError } from "utils";
import { useTranslations } from "hooks";
import { useSelector, useDispatch } from "react-redux";
import { placeBet, setAuth } from "./actions";
import { setBetbarParent } from "components/feature/betbar/actions";
import history from "router/history";

import styled from "styled-components";

const StyledWrapper = styled.div``;

const Wrapper = ({ setPicksData }) => {
  const dispatch = useDispatch();

  const [translations] = useTranslations();

  const { search } = useLocation();

  const { placeBetData } = useSelector((s) => s.auth);

  const redirect = `/${search.substring(search.indexOf("=") + 1, 100)}`;

  const handleSetBetbarParent = (betbar) => {
    dispatch(setBetbarParent(betbar));
  };

  const handlePlaceBetSuccess = () => {
    history.push("/");
  };

  const handleSuccess = (isFromSignupPage) => {
    if (placeBetData) {
      const {
        picks,
        activePickem,
        activePickemList,
        isEmailMarketingAccepted,
        profile,
      } = placeBetData;

      dispatch(
        placeBet(
          translations,
          handleSetBetbarParent,
          placeBetData?.picks,
          activePickem?.id,
          activePickem?.name,
          activePickemList,
          isEmailMarketingAccepted,
          profile,
          handlePlaceBetSuccess
        )
      );
      dispatch(
        setAuth({
          placeBetData: undefined,
        })
      );
    } else {
      history.push(redirect || "/");
    }

    // history.push(isFromSignupPage ? "/?signup=true" : "/profile");
  };

  const handleCancel = (isFromSignupPage) => {
    dispatch(
      setAuth({
        placeBetData: undefined,
      })
    );
    setPicksData({
      questionsAnswered: 0,
    });
    history.push(isFromSignupPage ? "/?signup=true" : "/profile");
  };

  return (
    <StyledWrapper>
      <ConfirmPhoneNumber
        translations={translations}
        onSuccess={handleSuccess}
        onError={handleError}
        onCancel={handleCancel}
        appIconUrl={createImageCdnLink(process.env.REACT_APP_CLUB_LOGO_SQUARE)}
      />
    </StyledWrapper>
  );
};

export default Wrapper;
